import { useQuery } from '@tanstack/react-query';
import { useUser } from '../contexts/UserContext';
import { calendarService } from '../services/calendarService';
import { settingsService } from '../services/settingsService';
import type { AccountConnections } from '../types/api';
import type { CalendarProviders } from '../types/calendar';

interface UseCalendarTypesOptions {
  enabled?: boolean;
}

export const useCalendarTypes = (options?: UseCalendarTypesOptions) => {
  const { enabled = true } = options ?? {};
  const { isTokenFresh } = useUser();

  return useQuery<AccountConnections>({
    queryKey: ['calendarTypes'],
    enabled: enabled && isTokenFresh,
    queryFn: async () => {
      calendarService.refreshAuthToken();
      const data = await calendarService.fetchCalendarTypes();

      const normalizedCalendar: CalendarProviders = {
        google: {
          connected: data.google?.connected ?? false,
          email: data.google?.email ?? null,
          login_link: data.google?.login_link ?? '',
        },
        microsoft: {
          connected: data.microsoft?.connected ?? false,
          email: data.microsoft?.email ?? null,
          login_link: data.microsoft?.login_link ?? '',
        },
      };

      const currentCalendar = settingsService.getSettings().calendar;
      if (JSON.stringify(currentCalendar) !== JSON.stringify(normalizedCalendar)) {
        await settingsService.updateSettings(
          { calendar: normalizedCalendar },
          { validate: false, persist: true },
        );
      }

      return data;
    },
    staleTime: Infinity, // never refetch automatically
  });
};
